import React, { useEffect, useRef } from 'react'
import { get } from 'lodash'
import { FormikDropdownField } from 'components/form/Dropdown'
import { FormikInputField } from 'components/form/InputField'
import { FormikTextareaField } from 'components/form/TextareaField'
import { FormikCheckboxField } from 'components/form/CheckboxField'
import { useDispatch } from 'react-redux'
import { countryList } from 'actions/country'
import { provinceList } from 'actions/province'
import { CommonTable } from 'components/CommonTable'
import AdminTableFilter from 'admin/components/common/AdminTableFilter'
import { Separator } from 'components/layout/Separator'
import { Button, Paper, Grid, makeStyles } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { AddButton } from 'components/form/Buttons'

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      padding: 15
    }
  },
  labelRoot: {
    paddingLeft: 15,
    fontSize: 24,
  },
  labelShinked: {
    marginLeft: 5,
    fontSize: 16
  },
  addLabel: {
    marginRight: 10
  },
  actions: {

    [theme.breakpoints.down('sm')]: {
      padding: 0,
      marginTop: -20,
      marginBottom: -15,
      marginLeft: -10,
      '& button': {
        width: 280,
        fontSize: 12
      },
    }
  },
  inTabs: {
    marginLeft: -24,
    marginRight: -24
  }
}))

const CommonListTable = ({
  title,
  active_key,
  add_label,
  button_variation,
  button_type,
  button_align,
  button_color,
  button_size,
  canDelete,
  onAddRow,
  showNumbers,
  noHeadings,
  noPagination,
  useColumnsSelector,
  storeTableName,
  renderAdditionalFilter,
  enableAnyFieldFilter,
  renderAdditionalActions,
  renderAdditionalLeftActions,
  onEditRow,
  is_loading,
  breadcrumbs,
  columns,
  item_list,
  inTabs
}) => {
    const classes = useStyles()
    const rows = item_list.getVisibleObjects()
    const dispatch = useDispatch()
    const componentRef = useRef(null)
    const style = inTabs ? classes.inTabs : classes.noTabs

    const onFilterChanged = (filter_values) => {
        dispatch(item_list.updateListFilter(filter_values))
        dispatch(item_list.fetchListIfNeeded())
    }

    const renderFilter = (formik_props) => {
        return (
            <div>
              { renderAdditionalFilter && renderAdditionalFilter(formik_props) }

              { enableAnyFieldFilter &&
                <FormikInputField name="any_field"
                                  formik_props={formik_props}
                                  show_search_icon={true}
                                  placeholder="Search..."
                                  InputLabelProps={{
                                    classes: {
                                      root: classes.labelRoot,
                                      shrink: classes.labelShinked
                                    }
                                  }}
                                  InputProps={
                                    {style:{
                                      borderRadius: '40px',
                                      paddingLeft: 15,
                                      fontSize: 24
                                    }
                                  }} />
              }
              <Separator variant="w5" />
            </div>
        )
    }
    let justifyContent
    let marginTop
    let marginRight
    switch(button_align) {
      case 'right':
        justifyContent = 'flex-end'
        marginTop = -40
        marginRight = -12
        break
      case 'left':
        justifyContent = 'flex-start'
        break
      case 'center':
        justifyContent = 'center'
        break
      default:
        justifyContent = "space-between"
    }

    return (
        <div className={classes.root}>
          <Grid container className={classes.actions} justify={justifyContent} direction="row" alignItems="center">

              { onAddRow &&
                <Grid item style={{marginTop: marginTop, marginRight: marginRight}}>
                  <AddButton
                    onClick={onAddRow}
                    label={add_label}
                    variant={button_variation}
                    type={button_type}
                    color={button_color}
                    align={button_align}
                    size={button_size}
                  />
                  <Separator height={10} />
                </Grid>
              }
              { renderAdditionalActions &&
                <Grid item>
                  { renderAdditionalActions() }
                 <Separator height={10} />
                </Grid>
              }

          </Grid>

          <AdminTableFilter
            label=""
            placeholder="Search"
            renderFilter={ renderFilter }
            updateOnChange={ onFilterChanged }
            style={{marginLeft: 10, marginRight: 10}}
          />

        <div className={style}>

            <CommonTable
              is_loading={ is_loading }
              rows={rows}
              columns={ columns }
              item_list={item_list}
              onEditRow={onEditRow}
              canDelete={canDelete}
              render_additional_filter={renderAdditionalFilter}
              useColumnsSelector={useColumnsSelector}
              storeTableName={storeTableName}
              showNumbers={showNumbers}
              noHeadings={noHeadings}
              noPagination={noPagination}
            />

          </div>

        </div>
  )
}

export default CommonListTable
